import gql from 'graphql-tag';

export const userInfoFieldsFragment = gql`
  fragment AdminUserInfoFields on UserInfo {
    sub
    email
    email_verified
    nickname
    name
    picture
    updated_at
  }
`;